import { render } from "./ModelCreate.vue?vue&type=template&id=0b263bf2"
import script from "./ModelCreate.vue?vue&type=script&lang=js"
export * from "./ModelCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__